import React, { useState } from 'react';
import { Copy, Check, FileDown, FileText, MessageCircle } from 'lucide-react';
import ShareToChat from './ShareToChat';

export default function MessageActions({ content, contentRef, onExportPdf, onGenerateMemo, sharePayload }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      const ta = document.createElement('textarea');
      ta.value = content;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <div className="flex items-center gap-0.5 mt-1">
      <button
        onClick={handleCopy}
        className="flex items-center gap-1 px-2 py-1 rounded-md text-[11px] text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-colors"
        title="Copy to clipboard"
      >
        {copied ? <Check className="w-3 h-3 text-emerald-500" /> : <Copy className="w-3 h-3" />}
        {copied ? 'Copied' : 'Copy'}
      </button>
      {onExportPdf && (
        <button
          onClick={() => onExportPdf(contentRef)}
          className="flex items-center gap-1 px-2 py-1 rounded-md text-[11px] text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-colors"
          title="Export as PDF"
        >
          <FileDown className="w-3 h-3" />
          PDF
        </button>
      )}
      {onGenerateMemo && (
        <button
          onClick={onGenerateMemo}
          className="flex items-center gap-1 px-2 py-1 rounded-md text-[11px] text-muted-foreground hover:text-foreground hover:bg-secondary/60 transition-colors"
          title="Generate IC Memo"
        >
          <FileText className="w-3 h-3" />
          Memo
        </button>
      )}
      {sharePayload && (
        <ShareToChat
          messageType={sharePayload.messageType || 'shared_ai'}
          payload={sharePayload}
          defaultComment={sharePayload.defaultComment || ''}
        />
      )}
    </div>
  );
}
